import { Component, Inject, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SendAction, VerifyAction } from 'src/app/shared/interfaces/auth.interface';
import { ResponseData } from '../../interfaces/response.interface';
import { Verify2FAComponent } from './verify-2fa.component';

@Component({
  selector: 'verify-2fa-dialog',
  standalone: true,
  template: `
    <verify-2fa
      #verify2fa
      [isSpecificType]="data.isSpecificType ?? false"
      [header]="data.header ?? ''"
      [title]="data.title ?? ''"
      [description]="data.description ?? ''"
      [email]="data.email ?? ''"
      [mobile]="data.mobile ?? ''"
      [areaCode]="data.areaCode ?? ''"
      [otpType]="data.otpType ?? 'Login'"
      [sendType]="data.sendType ?? 'Email'"
      [uniCode]="data.uniCode ?? null"
      [submitFunc]="data.submitFunc ?? null"
      [verifyFunc]="data.verifyFunc ?? null"
      (verifyResponse)="data.verifyResponse ? data.verifyResponse($event) : null"
      (sendTypeChange)="data.sendTypeChange ? data.sendTypeChange($event) : null"
    />
  `,
  imports: [Verify2FAComponent],
})
export class Verify2FADialogComponent {
  @ViewChild('verify2fa') verify2fa!: Verify2FAComponent;

  constructor(
    public dialogRef: MatDialogRef<Verify2FADialogComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      isSpecificType?: boolean;
      header?: string;
      title?: string;
      description?: string;
      email?: string;
      mobile?: string;
      areaCode?: string;
      otpType?: VerifyAction;
      sendType?: SendAction;
      uniCode?: string | null;
      verifyFunc?: ((data: ResponseData<string>) => Promise<boolean>) | null;
      submitFunc?: ((codes: string, verifyType?: 'EMAIL' | 'GOOGLE' | 'MOBILE') => Promise<boolean>) | null;
      verifyResponse?: (result: any) => void;
      sendTypeChange?: (sendType: SendAction) => void;
    },
  ) {}
}
